export const PREVIEW_NODE_KIND = {
  GROUP: 'group',
  LEAF: 'leaf',
};

export const PREVIEW_NODE_STATUS = {
  UNCHANGED: 'unchanged',
  ADDED: 'added',
  REMOVED: 'removed',
};

export const PREVIEW_GROUP_OPERATOR = {
  AND: 'AND',
  OR: 'OR',
};

export const PREVIEW_GROUP_OPERATOR_PILL_LABEL = {
  [PREVIEW_GROUP_OPERATOR.AND]: 'ALL',
  [PREVIEW_GROUP_OPERATOR.OR]: 'ANY',
};

export const PREVIEW_GROUP_OPERATOR_DESCRIPTION = {
  [PREVIEW_GROUP_OPERATOR.AND]: 'must be true',
  [PREVIEW_GROUP_OPERATOR.OR]: 'may be true',
};

export const PREVIEW_GROUP_COUNT_SUFFIX_SINGULAR = 'condition';
export const PREVIEW_GROUP_COUNT_SUFFIX_PLURAL = 'conditions';

export const PREVIEW_LEAF_UNRENDERABLE_LABEL =
  'This clause could not be rendered in plain English.';

export const PREVIEW_STATUS_GLYPH = {
  [PREVIEW_NODE_STATUS.ADDED]: '+',
  [PREVIEW_NODE_STATUS.REMOVED]: '\u2212',
  [PREVIEW_NODE_STATUS.UNCHANGED]: '\u2022',
};

export const PREVIEW_STATUS_BADGE_LABEL = {
  [PREVIEW_NODE_STATUS.ADDED]: 'New',
  [PREVIEW_NODE_STATUS.REMOVED]: 'Removed',
};

export const PREVIEW_EXPAND_ALL_LABEL = 'Expand all';
export const PREVIEW_COLLAPSE_ALL_LABEL = 'Collapse all';

export const PREVIEW_DEFAULT_COLLAPSED_LEAF_THRESHOLD = 5;

export const PREVIEW_EXPLAIN_BUTTON_LABEL = 'Explain';
export const PREVIEW_EXPLAIN_HIDE_BUTTON_LABEL = 'Hide explanation';
export const PREVIEW_EXPLAIN_LOADING_HELPER = 'Explaining\u2026';
export const PREVIEW_EXPLAIN_ERROR_HELPER = 'Could not generate an explanation for this clause.';
